module.exports = __webpack_public_path__ + "static/media/our_cust.a691dac6.svg";